// Error Display Actions
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
export const HIDE_ERROR_MESSAGE = 'HIDE_ERROR_MESSAGE';
export const CLEAR_ERROR_DISPLAY = 'CLEAR_ERROR_DISPLAY';
export const DISMISS_ERROR_MESSAGE = 'DISMISS_ERROR_MESSAGE';
export const DISPLAY_ERROR_MESSAGE = 'DISPLAY_ERROR_MESSAGE';
export const HIDE_ERROR_DISPLAY = 'HIDE_ERROR_DISPLAY';
export const CLEAR_ERROR_DISPLAY_STATE = 'CLEAR_ERROR_DISPLAY_STATE';

// Action Creators
export const showErrorMessage = (message, type, context, duration = 5000) => ({
  type: SHOW_ERROR_MESSAGE,
  payload: { message, type, context, duration }
});

export const hideErrorMessage = () => ({
  type: HIDE_ERROR_MESSAGE
});

export const clearErrorDisplay = () => ({
  type: CLEAR_ERROR_DISPLAY
});

export const dismissErrorMessage = (reason = 'user_dismissed') => ({
  type: DISMISS_ERROR_MESSAGE,
  payload: { reason }
});

export const displayErrorMessage = (message, type, context, timestamp) => ({
  type: DISPLAY_ERROR_MESSAGE,
  payload: { message, type, context, timestamp }
});

export const hideErrorDisplay = () => ({
  type: HIDE_ERROR_DISPLAY
});

export const clearErrorDisplayState = () => ({
  type: CLEAR_ERROR_DISPLAY_STATE
});
